import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=6391b3ba&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6391b3ba')) {
      api.createRecord('6391b3ba', component.options)
    } else {
      api.reload('6391b3ba', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=6391b3ba&", function () {
      api.rerender('6391b3ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/comp/FavElement.vue"
export default component.exports